import * as React from "react";
import {Box, Card, CardContent, Grid, Skeleton, Typography, useMediaQuery, useTheme, styled} from "@mui/material";
import { BlueContainer } from "../MonthlyExpenses/MonthlyExpensesLayoutComponents";
import { Container, ItemContainer, OuterContainer } from "../MonthlyExpenses/MoneyLeftLayoutComponents";

const getRandomArbitrary = (min: number, max: number): number => {
    return Math.random() * (max - min) + min;
}


export const StyledItemContainer = styled(ItemContainer)(({theme}) => ({
    [theme.breakpoints.up('xs')]: {
        '> *:first-child': {
            marginBottom: 10,
        },
    },

    [theme.breakpoints.only('xs')]: {
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1),

        '&:last-of-type': {
            marginBottom: 0,
        },
    },
}));

export const LoadingPlaceholders = () => {
    const isSmallScreen = useMediaQuery(useTheme().breakpoints.down('sm'));

    const pieSize = isSmallScreen ? 140 : 150;
    const currentPrimaryTextLength = isSmallScreen ? 130 : 200;
    const currentSecondaryTextLength = isSmallScreen ? 170 : 200;

    const spendingPrimaryText = isSmallScreen ? 200 : 230;

    return (
        <Grid container spacing={isSmallScreen ? 1 : 3}>
            <Grid size={{ xs: 12, md: 6, xl: 4 }}>
                <BlueContainer>
                    <Box sx={{display: 'flex'}}>
                        <Skeleton variant="circular" width={pieSize} height={pieSize} />
                        <Box sx={{marginTop: 3, marginLeft: 4}}>
                            <Skeleton variant="text" width={currentPrimaryTextLength} height={15} />
                            <Skeleton variant="text" width={100} height={80} sx={{marginTop: -0.5}} />
                            <Skeleton variant="text" width={currentSecondaryTextLength} height={15} />
                        </Box>
                    </Box>
                </BlueContainer>
            </Grid>
            <Grid size={{ xs: 12, md: 6, xl: 8 }}>
                <OuterContainer>
                    <Container>
                        <StyledItemContainer>
                            <Skeleton variant="rectangular" width={120} height={40} />
                            <Skeleton variant="text" width={spendingPrimaryText} height={15} sx={{marginTop: -0.5}} />
                        </StyledItemContainer>
                        <StyledItemContainer>
                            <Skeleton variant="rectangular" width={120} height={40} />
                            <Skeleton variant="text" width={spendingPrimaryText} height={15} sx={{marginTop: -0.5}} />
                        </StyledItemContainer>
                        <StyledItemContainer>
                            <Skeleton variant="rectangular" width={120} height={40} />
                            <Skeleton variant="text" width={spendingPrimaryText} height={15} sx={{marginTop: -0.5}} />
                        </StyledItemContainer>
                    </Container>
                </OuterContainer>
            </Grid>
            <Grid size={{ xs: 12, xl: 6 }} sx={{'& > *': {height: '100%'}}}>
                <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Budgets
                        </Typography>

                        {['','','',''].map((_, idx) => (
                            <Box key={idx} sx={{marginBottom: 2}}>
                                <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                                    <Skeleton variant="text" width={getRandomArbitrary(70, 100)} height={12} />
                                    <Skeleton variant="text" width={100} height={12} />
                                </Box>
                                
                                <Skeleton variant="rounded" width="100%" height={12} />
                            </Box>
                        ))}
                    </CardContent>
                </Card>
            </Grid>
            <Grid size={{ xs: 12, xl: 6 }} sx={{'& > *': {height: '100%'}}}>
            <Card>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>
                            Upcoming Payments
                        </Typography>

                        {['','','',''].map((_, idx) => (
                            <Box key={idx} sx={{marginBottom: 2}}>
                                <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                                    <Skeleton variant="text" width={getRandomArbitrary(100, 200)} height={25} />
                                    <Skeleton variant="text" width={100} height={25} />
                                </Box>
                                
                                <Skeleton variant="text" width={getRandomArbitrary(30, 80)} height={12} />
                                <Skeleton variant="text" width={getRandomArbitrary(30, 80)} height={12} />
                            </Box>
                        ))}
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
    );
};
